import { FormattedMessage } from "react-intl";
import FloatSpinner from "../../components/FloatSpinner/FloatSpinner";
import classes from "./MainContentContainer.module.scss";
import messages from "../../module/messages";
import { selectFloatingSpinner } from "../../App/module/selectors";
import { createStructuredSelector } from "reselect";
import { connect } from "react-redux";

interface IMainContentContainerProps {
  children: JSX.Element | JSX.Element[];
  showFloatSpinner: boolean;
}

const MainContentContainer = (props: IMainContentContainerProps) => {
  const { children, showFloatSpinner } = props;
  return (
    <div className={classes["main-content"]}>
      {showFloatSpinner && (
        <FloatSpinner
          textContent={<FormattedMessage {...messages.loading} />}
        />
      )}
      {children}
    </div>
  );
};

const mapStateToProps: any = () =>
  createStructuredSelector({
    showFloatSpinner: selectFloatingSpinner,
  });

const withConnect: any = connect(mapStateToProps, null);

export default withConnect(MainContentContainer);
